import { useNavigate } from "react-router-dom";
import { CaseNumberHandler, CaseStateHandler, CreatedDateHandler } from "./service";
import { useCallback, useRef, useState } from "react";
import { Alert, Button, Form, Modal, Input, message } from "antd";
import List from "../grid.component";
import apiCalls from "src/api/apiCalls";
import { useSelector } from "react-redux";
import Loader from "../shared/loader.component";
import SelectInput from "../shared/selectInput";
import ErrorMessage from "../shared/messages/errorMessage";
const { TextArea } = Input;
import ActionsComponent from "../shared/ActionsComponent";
import GridLayout from "../shared/gridLayout";
const CasesGrid = () => {
  const navigate = useNavigate();
  const gridRef = useRef(null);
  const [isExcelExport, setIsExcelExport] = useState(false);
  const [checkboxSelection, setCheckboxSelection] = useState([]);
  const [checkBoxData, setCheckBoxData] = useState({})
  const [errorMessage, setErrorMessage] = useState(null);
  const [reason, setReason] = useState("");
  const [isStateModal, setIsStateModal] = useState(false);
  const [statechangeErr, setStatechangeErr] = useState(null);
  const [statechange, setStatechange] = useState("");
  const [modelLoader, setModelLoader] = useState(false);
  const userData = useSelector(state => state.oidc?.adminDetails?.currentUser)
  const [selectedObj, setSelectedObj] = useState({})
  const [buttonLoader, setButtonLoader] = useState(false);
  const [lookUp, setLookUp] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [form] = Form.useForm();
  const handleCheckboxChanges = useCallback(
    (prop, e) => {
      setErrorMessage(null);
      setStatechangeErr(null)
      if (e.target.checked) {
        const rowChecked = prop.dataItem;
        let _selection = [...checkboxSelection];
        let idx = _selection.indexOf(rowChecked.id);
        if (checkboxSelection) {
          _selection = [];
        }
        if (idx > -1) {
          _selection.splice(idx, 1);
        } else {
          _selection.push(rowChecked.id);
        }
        setCheckBoxData(rowChecked);
        setCheckboxSelection(_selection);
        setSelectedObj(rowChecked)
      } else {
        setCheckBoxData({});
        setCheckboxSelection([]);
        setSelectedObj('')
      }
    }, [checkboxSelection]);
  const caseViewHandler = useCallback((data) => () => {
    navigate(`/caseView/${data?.id}/${data?.state}`)
  }, [navigate])
  const caseNumberHandler = useCallback((props) => {
    return <CaseNumberHandler data={props?.dataItem} caseViewHandler={caseViewHandler} />
  }, [caseViewHandler])
  const createdDateHandler = useCallback((props) => {
    return <CreatedDateHandler data={props?.dataItem} />
  }, [])
  const caseStateHandler = useCallback((props) => {
    return <CaseStateHandler data={props?.dataItem} />
  }, [])
  const customcells = {
    "caseNumber": caseNumberHandler,
    "createdDate": createdDateHandler,
    "state": caseStateHandler,
  };
  const renderCustomCell = useCallback(
    (props, column) => {
      if (customcells[column.field]) {
        return customcells[column.field](props);
      }
    }, [customcells]);
  const handleExcelExport = () => {
    setIsExcelExport(true);
    setTimeout(() => {
      setIsExcelExport(false)
    });
    message.destroy();
    message.success({
      content: 'Download Excel Successfully',
      className: 'custom-msg',
      duration: 3
    });
  }
  const openStateChangeModal = async () => {
    if (checkboxSelection?.length === 0) {
      setErrorMessage("Please select one record");
      return;
    }
    if (checkBoxData?.isAdmin === false) {
      setErrorMessage("Please select admin case. Super admin cases can't change state");
      return;
    }
    try {
      setModelLoader(true);
      setErrorMessage(null);
      const response = await apiCalls.getStateChangeLu(selectedObj?.state);
      if (response) {
        setErrorMessage(null);
        setLookUp(response?.data)
        setTimeout(() => {
          setModelLoader(false);
        }, 1000);
        setStatechange(selectedObj?.state)
        setIsStateModal(true);
      }
    } catch (error) {
      setErrorMessage(apiCalls.isErrorDispaly(error));
      setCheckboxSelection([])
    }
  };
  const closeStateChangeModal = useCallback(() => {
    form.resetFields('');
    setIsStateModal(false);
    setCheckboxSelection([])
    setStatechange("")
    setCheckBoxData({});
    setSelectedObj('')
  }, [form])
  const updateState = useCallback(async () => {
    const statusObj = {
      id: selectedObj?.id,
      modifiedBy: userData?.userName,
      status: statechange,
      Laststatus: selectedObj?.state,
      reason: statechange === "Reopened" ? reason : null,
    };
    setButtonLoader(true);
    try {
      const response = await apiCalls.updateStateChange(statusObj);
      if (response.ok) {
        setIsStateModal(false);
        setStatechangeErr("");
        setCheckboxSelection([]);
        setStatechange("");
        setCheckBoxData({});
        setRefreshKey((prev) => prev + 1);
        message.success({
          content: `Record ${statechange} successfully`,
          className: "custom-msg",
          duration: 2,
        });
      } else {
        setStatechangeErr(apiCalls.isErrorDispaly(response));
      }
    } catch (error) {
      setStatechangeErr(apiCalls.isErrorDispaly(error));
    } finally {
      setButtonLoader(false);
      setStatechange("");
      setCheckboxSelection([]);
    }
  }, [selectedObj, userData, statechange, reason, apiCalls]);

  const closeError = useCallback(() => {
    setErrorMessage(null)
  }, [])
  const editExistingCase = () => {
    if (checkboxSelection?.length === 0) {
      setErrorMessage("Please select one record");
      return;
    }
    if (checkBoxData?.isAdmin === false) {
      setErrorMessage("Please select admin case. Super admin cases can't edit");
      return;
    }
    navigate(`/cases/edit/${selectedObj?.id}/Cases/${selectedObj?.state}`);
  }
  const handleToolBarActions = (action) => {
    if (checkboxSelection?.length === 0 && action !== 'exportexcel') {
      setErrorMessage("Please select one record!")
      return;
    }
    switch (action) {
      case 'edit':
        editExistingCase()
        break;
      case 'statechange':
        openStateChangeModal()
        break;
      case 'exportexcel':
        handleExcelExport()
        break;
      default:
        return;
    }
  }
  const onActionClick = useCallback((key) => {
    handleToolBarActions(key)
  }, [handleToolBarActions])
  const closeStateChangeError = useCallback(() => {
    setStatechangeErr(null)
  }, [])
  const handleStateChange = useCallback((value) => {
    setStatechange(value)
    form.setFieldsValue({ statechange: value });
  }, [form])
  const handleReason = useCallback((e) => {
    setReason(e.target.value)
  }, [])
  return (
    <div className=''>
      <div className='flex justify-end gap-2 mb-3'>
        <ActionsComponent serviceName={"CardsManageService.Cases"} onActionClick={onActionClick} targetTabName="Cases" />
        <GridLayout />
        <div className='flex justify-end items-center space-x-1.5 mb-2'>
        </div>
      </div>
      {errorMessage &&
        <div className='mb-4'>
          <Alert
            className='mb-4'
            type="error"
            description={errorMessage}
            onClose={closeError}
            showIcon
            closable
          />
        </div>
      }
      {isStateModal && (
        <Modal
          className="modal-p-body"
          closeIcon={<span className="icon close"></span>}
          onCancel={closeStateChangeModal}
          title="State Change"
          open={isStateModal}
          footer={
            null
          }
          destroyOnClose={true}
        >
          <div className="">
            {statechangeErr && (
              <div className="mb-4">
                <ErrorMessage
                  msg={statechangeErr}
                  onClose={closeStateChangeError}
                />
              </div>
            )}
            {modelLoader === true ? <Loader /> : (<Form onFinish={updateState} initialValues={selectedObj} >
              <Form.Item name="statechange">
                <SelectInput
                  fieldName="Admin State"
                  showSearch={false}
                  options={lookUp}
                  defaultValue={selectedObj?.state}
                  onChange={handleStateChange}
                  label="Select State"
                  required
                  allowClear={false}
                />
              </Form.Item >
              {(statechange === 'Reopened') && (<div className=" custom-user-input">
                <Form.Item
                  name="reason"
                  className="custom-input"
                  rules={[{ required: true, message: "Is required" }]}
                  label="Remarks"
                >
                  <TextArea label="Remarks" required placeholder="Reason For Reopened" maxLength={50} onChange={handleReason} showCount={200} rows={3} className="bg-transparent" />
                </Form.Item>
              </div>)}
              <div className="mt-5 md:flex justify-end gap-2 space-y-2 md:space-y-0">
                <Button key="back" type="default" className=" cancel-btn" onClick={closeStateChangeModal}>
                  Cancel
                </Button>
                <Button
                  key="submit"
                  type="primary"
                  loading={buttonLoader}
                  htmlType="submit"
                  className="primary-btn"
                >
                  Save
                </Button>
              </div>
            </Form>)}
          </div>
        </Modal>
      )}
      <List
        key={refreshKey}
        url={process.env.REACT_APP_GRID_API + `api/CaseManagement/GetCaseK`}
        pSize={10}
        className="custom-grid"
        ref={gridRef}
        showExcelExport={isExcelExport}
        pKey={"Cases"}
        screenName={'Cases'}
        renderCustomCell={renderCustomCell}
        handleSelection={handleCheckboxChanges}
        showGridSelection={true}
        selection={[checkBoxData?.id]}
      />
    </div>
  )
}
export default CasesGrid